import React, { useState, useEffect } from "react";
import {
    Container,
    Card,
    Button,
    Row,
    Col,
    Form,
    Spinner,
} from "react-bootstrap";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import config from "../../../config";

const UnlistedLeadForm = ({ leadData, onCancel, onSuccess }) => {
    const isEdit = !!leadData;
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        unlisted_venue_name: "",
        unlisted_venue_location: "",
        customer_name: "",
        contact_number: "",
        email: "",
        remarks: "",
    });

    const tokenConfig = {
        headers: { Authorization: `Token ${sessionStorage.getItem("tokenKey")}` },
    };

    useEffect(() => {
        if (isEdit && leadData) {
            setFormData({
                unlisted_venue_name: leadData.unlisted_venue_name || "",
                unlisted_venue_location: leadData.unlisted_venue_location || "",
                customer_name: leadData.customer_name || "",
                contact_number: leadData.contact_number || "",
                email: leadData.email || "",
                remarks: leadData.remarks || "",
            });
        }
    }, [isEdit, leadData]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const url = isEdit
                ? `${config.service}/leads_v2/leads/${leadData.id}/`
                : `${config.service}/leads_v2/leads/`;

            const method = isEdit ? "put" : "post";

            await axios({
                method,
                url,
                data: formData,
                ...tokenConfig,
            });

            toast.success(`Unlisted lead ${isEdit ? "updated" : "created"} successfully!`);
            if (onSuccess) onSuccess();
        } catch (error) {
            console.error("Error saving unlisted lead:", error);
            toast.error(
                error.response?.data?.message || "An error occurred. Please try again."
            );
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="p-0">
            <Card>
                <Card.Header className="d-flex justify-content-between align-items-center">
                    <h5>{isEdit ? "Edit Unlisted Lead" : "Create Unlisted Lead"}</h5>
                    <div>
                        <Button variant="secondary" className="me-2" onClick={onCancel}>
                            Cancel
                        </Button>
                        <Button variant="primary" onClick={handleSubmit} disabled={loading}>
                            {loading ? <Spinner animation="border" size="sm" /> : "Save"}
                        </Button>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Venue Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="unlisted_venue_name"
                                        value={formData.unlisted_venue_name}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Location</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="unlisted_venue_location"
                                        value={formData.unlisted_venue_location}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Customer Name</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="customer_name"
                                        value={formData.customer_name}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Contact Number</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="contact_number"
                                        value={formData.contact_number}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={6}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Email</Form.Label>
                                    <Form.Control
                                        type="email"
                                        name="email"
                                        value={formData.email}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                            <Col md={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Remarks</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={3}
                                        name="remarks"
                                        value={formData.remarks}
                                        onChange={handleInputChange}
                                    />
                                </Form.Group>
                            </Col>
                        </Row>
                    </Form>
                </Card.Body>
            </Card>
            <ToastContainer position="top-center" autoClose={3000} hideProgressBar />
        </Container>
    );
};

export default UnlistedLeadForm;
